$(".btn-addPrinter").click(function() {
    $(".my-printer-warp .myPrinter").hide();
    $(".my-printer-warp .add-printer").show()
    $(".my-printer-warp .my-printer-nav span").eq(1).addClass("my-printer-nav-on").siblings().removeClass("my-printer-nav-on");
});
$(".my-printer-warp .my-printer-nav span").click(function() {
    $(this).addClass("my-printer-nav-on").siblings().removeClass("my-printer-nav-on");
    var index = $(this).index();
    if (index == 0) {
        $(".my-printer-warp .myPrinter").show();
        $(".my-printer-warp .add-printer").hide()
    } else {
        $(".my-printer-warp .myPrinter").hide();
        $(".my-printer-warp .add-printer").show()
    }
});
function getMyPrinter() {
    var myPrinter = [];
    if (localStorage.myPrinter) {
        myPrinter = JSON.parse(localStorage.myPrinter)
    }
    var template0 = $("#myPrinter-item-template").html();
    var template = "";
    $.each(myPrinter,
    function(key, val) {
        var template1 = template0;
        template1 = template1.replace(/hreft/g, "href");
        template1 = template1.replace(/{printer.title}/g, val["model"]);
        template1 = template1.replace(/{printer.brand}/g, val["brand"]);
        template1 = template1.replace(/{printer.url}/g, val["url"]);
        template += template1
    });
    if (template) {
        $("#myPrinter-item").html(template)
    }
    $("#myPrinter-item").show()
}
getMyPrinter();
$(".icon-subtract").click(function() {
    var title = $(this).attr("title");
    layer.confirm("Are you sure you want to delete this " + title + " from My Printers?：", {
        btn: ["Remove ", "Cancel "],
        title: "message",
    },
    function() {
        layer.msg("SUCCEED", {
            icon: 1
        });
        var myPrinter0 = {};
        if (localStorage.myPrinter) {
            myPrinter0 = JSON.parse(localStorage.myPrinter)
        }
        var myPrinter = {};
        $.each(myPrinter0,
        function(key, val) {
            if (key != title) {
                myPrinter[key] = val
            }
        });
        localStorage.myPrinter = JSON.stringify(myPrinter);
        window.location.reload()
    },
    function() {});
    return false
});
$("body").on('mouseover mouseout','.brand-item,.series-item',function(event) {
    if(event.type == "mouseover"){
        //鼠标悬浮
      $(this).addClass("printer-item-hover")
    }else if(event.type == "mouseout"){
        //鼠标离开
       $(this).removeClass("printer-item-hover")
    }
    
})
$("body").on('click','.brand-item',function() {
  $(".printer-set").removeClass("existyesPrinter");//2022/07 
    clearF();//2022/07 清空文本框内容
    $(".brand-item").removeClass("printer-item-on");
    $(".series-item").removeClass("printer-item-on");
    $(this).addClass("printer-item-on");
    var brand = $(this).attr("brand");
    $("#ul_printer_01").css("display", "flex");
    $(".product .add-printer-list").hide();
    $(".product .add-printer-list").removeClass("selectUlShow");// 2022/07 新增
});
$("body").on('click','.series-item',function() {
  if(!$(".printer-set").hasClass("existyesPrinter")){
      $(".printer-set").addClass("existyesPrinter");
    }//2022/07 显示搜索框
    clearF();//2022/07 清空文本框内容
    $(".series-item").removeClass("printer-item-on");
    $(".product-item").removeClass("printer-item-on");
    $(this).addClass("printer-item-on");
    var series = $(this).attr("series");
    var brand = $(this).attr("brand");
    $("#ul_printer_02").css("display", "flex");
    $("#ul_printer_02").addClass("selectUlShow");
});
$("body").on('click','.product-item',function() {
    $(this).toggleClass("printer-item-on")
});
$("#submit").click(function() {
    var myPrinter = {};
    if (localStorage.myPrinter) {
        myPrinter = JSON.parse(localStorage.myPrinter)
    }
    var LayerStr = "";
    $(".product .printer-item-on").each(function() {
        var str = "";
        var brand = $(this).attr("brand");
        var printer = $(this).attr("printer");
        var url = $(this).attr("url");
        str = printer + "（" + brand + "）";
        if (LayerStr) {
            LayerStr += "；"
        }
        LayerStr += str;
        myPrinter[str] = {
            "model": printer,
            "brand": brand,
            "url": url
        }
    });
    if(!LayerStr){
       layer.open({
          title: 'information',
          shadeClose: true, //开启遮罩关闭
          btn: ['confirm'], //按钮
          skin: 'layui-layer-rim', //加上边框
          content: '<div class="layer-code">Select a PRINTER</div>'
        });
		return false;
    }
    layer.confirm("Save to My Printers：" + LayerStr, {
        shadeClose: true, //开启遮罩关闭
        btn: ["Add ", "Cancel "],
        title: "message",
    },
    function() {
        layer.msg("SUCCEED", {
            icon: 1
        });
        localStorage.myPrinter = JSON.stringify(myPrinter);
        window.location.reload()
    },
    function() {})
});
$("#add-printer-c").click(function() {});
// 2022/07 新增搜索功能
//清空文本框内容
function clearF(){
  $('.search_type').val("");
  $('.printer-set').find(".findNoPrinter").removeClass("existNoPrinter"); 
  $(".product li").removeClass("viewingScree");
  $(".product li").removeClass("reveal");
}
    $(".input_clean").click(function(){
    	clearF();
    });
 //键盘按下事件：keydown() 是在键盘按下就会触发
    //键盘弹起事件：keyup() 是在键盘松手就会触发
    $(".keyup").keyup(function (e) {
        var valTe=$(this).val().toLowerCase();
        $('.printer-set').find(".findNoPrinter").addClass("existNoPrinter"); 
        var findRF=$(".product .selectUlShow li");
      
        $(findRF).removeClass("viewingScree");
        $(findRF).removeClass("reveal");
        if(valTe != ""){
          $(findRF).each(function(){
            if($(this).find('.printer-title').html().toLowerCase().indexOf(valTe) >= 0){
              console.log($(this).find('.printer-title').html());
              $(this).addClass("reveal");
            }
            $(this).addClass("viewingScree");
          });
          
           //判断findNoPrinter的兄弟是否存在reveal的Class类
          if($(findRF).is('.reveal')){
            $('.printer-set').find(".findNoPrinter").removeClass("existNoPrinter"); 
          }
        }else{
          $('.printer-set').find(".findNoPrinter").removeClass("existNoPrinter"); 
        }
    });
// 2022/07 新增搜索功能 结束